import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/common/states';

export function NotFoundPage() {
  return (
    <EmptyState
      title="Página não encontrada"
      description="O endereço acessado não existe ou foi removido."
      action={
        <Button asChild>
          <Link to="/">Voltar para a visão geral</Link>
        </Button>
      }
    />
  );
}
